window.addEventListener('load', function () {
    document.querySelectorAll('.splide').forEach(el => {
        const splide = new Splide(el, {
            autoWidth: true,
            omitEnd: true,
            focus: 0
        });
        splide.mount();
    });
});